<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('mailings') }} -> {{ $t('create-mailing') }}
    </h1>
    <div class="main__body">
      <div class="row">
        <div class="form-block">
          <div class="form-group">
            <label>{{ $t('name-mailing') }}</label>
            <input class="large" type="text" v-model="mailing.name" :placeholder="$t('name-mailing')">
            <span class="error" v-if="errors.name">{{ errors.name[0] }}</span>
          </div>
          <div class="form-group" v-if="this.mailing.social == 4">
            <label>{{ $t('header-mailing') }}</label>
            <input class="large" type="text" v-model="mailing.header" :placeholder="$t('header-mailing')">
            <span class="error" v-if="errors.header">{{ errors.header[0] }}</span>
          </div>
          <div class="form-group">
            <label>{{ $t('message') }}</label>
            <textarea class="large" :placeholder="$t('size-for-message')" v-model="mailing.text" v-if="this.mailing.social != 4"></textarea>
            <a v-if="this.mailing.social == 4" class="link-blue like__text-area" @click="showUploadFileModal">{{ $t('upload-email-html-format') }}</a>
            <span class="error" v-if="errors.message">{{ errors.message[0] }}</span>
          </div>
        </div>
        <div class="form-block">
          <div class="form-group">
            <label>{{ $t('date-and-time-mailing') }}</label>
            <input class="large" type="datetime-local" v-model="mailing.date">
            <span class="error" v-if="errors.date_send">{{ errors.date_send[0] }}</span>
          </div>
          <div class="form-group">
            <label>{{ $t('select-segment') }} {{ $t('or') }} <router-link class="link-blue" to="create-segment">{{ $t('create') }} {{ $t('his') }}</router-link></label>
            <select class="custom-select large" v-model="mailing.segment">
              <option v-for="item in segments" v-bind:key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
            <a class="link-blue mt-2" @click="showUploadImageModal" v-if="this.mailing.social == 1 || this.mailing.social == 2">{{ !this.mailing.image ? $t('upload-image-content') : this.mailing.image.name }}</a>
          </div>
          <div class="form-group" v-if="this.mailing.social == 4">
            <label>Выберите почту</label>
            <select class="custom-select large" v-model="mailing.mail">
              <option value="">Выберите почту</option>
              <option v-for="item in mails" v-bind:key="item.id" :value="item.id">{{ item.login }}</option>
            </select>
            <span class="error" v-if="errors.mail_id">{{ errors.mail_id[0] }}</span>
          </div>
          <div class="form-group" v-if="this.mailing.social == 3">
            <label>Имя отправителя</label>
            <select class="custom-select large" v-model="mailing.sms">
              <option value="">Имя отправителя</option>
              <option v-for="item in smses" v-bind:key="item.id" :value="item.id" v-if="item.confirm == 1">{{ item.name }}</option>
            </select>
            <span class="error" v-if="errors.mail_id">{{ errors.mail_id[0] }}</span>
          </div>
        </div>
        <div class="form-block">
          <h5 class="mb-2">{{ $t('variables-for-mailing') }}:</h5>
          <p>%имя% - {{ $t('variables-name') }}</p>
          <p>%фамилия% - {{ $t('variables-surname') }}</p>
          <p>%отчество% - {{ $t('variables-lastname') }}</p>
          <p>%телефон% - {{ $t('variables-phone') }}</p>
          <p>%email% - {{ $t('variables-email') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="form-block">
          <div class="form-group">
            <label>{{ $t('send') }} {{ $t('in') }}</label>
            <div class="social-block">
              <div class="social-item">
                <div class="social-img"><img src="@/assets/social/telegram.svg"></div>
                <div class="social-label"><label>Telegram</label></div>
                <div class="social-radio">
                  <input class="radio_input" name="social" id="telegram" type="radio" :value="1" v-model="mailing.social" checked>
                  <label class="radio_label" for="telegram"></label>
                </div>
              </div>
              <div class="social-item">
                <div class="social-img"><img src="@/assets/social/viber.svg"></div>
                <div class="social-label"><label>Viber</label></div>
                <div class="social-radio">
                  <input class="radio_input" name="social" id="viber" type="radio" :value="2" v-model="mailing.social">
                  <label class="radio_label" for="viber"></label>
                </div>
              </div>
              <div class="social-item">
                <div class="social-img"><img src="@/assets/social/sms.svg"></div>
                <div class="social-label"><label>SMS</label></div>
                <div class="social-radio">
                  <input class="radio_input" name="social" id="sms" type="radio" :value="3" v-model="mailing.social">
                  <label class="radio_label" for="sms"></label>
                </div>
              </div>
              <div class="social-item">
                <div class="social-img"><img src="@/assets/social/email.svg"></div>
                <div class="social-label"><label>Email</label></div>
                <div class="social-radio">
                  <input class="radio_input" name="social" id="email" type="radio" :value="4" v-model="mailing.social">
                  <label class="radio_label" for="email"></label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <a class="btn btn-primary" @click="showAcceptMoneyModal">{{ $t('save') }}</a>
          </div>
        </div>
      </div>
    </div>
    <upload-image-modal v-show="isModalUploadImageVisible"
                          @close="closeUploadImageModal"/>
    <upload-file-modal v-show="isModalUploadFileVisible"
                        @close="closeUploadFileModal"/>
    <accept-mailing-money :aSegments="segments" :selectedSegment="mailing.segment" :method="mailing.social" v-show="isModalAcceptMoneyModal"
                       @close="closeAcceptMoneyModal"/>
  </div>
</template>

<script>
import axios from 'axios'
import 'vue-loading-overlay/dist/vue-loading.css';
import uploadImageModal from "../components/modal/uploadImageModal";
import uploadFileModal from "../components/modal/uploadFIleModal";
import AcceptMailingMoney from "../components/modal/acceptMailingMoney";
export default {
  name: 'create-segment',
  data: function(){
    return{
      mailing: {
        name: '',
        header: '',
        date: '',
        text: '',
        segment: 0,
        social: 1,
        image: null,
        mail: '',
        sms: ''
      },
      smses: [],
      mails: [],
      isModalUploadImageVisible: false,
      isModalUploadFileVisible: false,
      isModalAcceptMoneyModal: false,
      segments: [],
      errors: [],
    }
  },
  watch: {
    isModalUploadImageVisible: function () {
      var $this = this;
      this.$root.$on('image', function(val){
        $this.mailing.image = val;
      });
    },
    isModalUploadFileVisible: function () {
      var $this = this;
      this.$root.$on('file', function(val){
        $this.uploadFile(val);
      });
    },
  },
  created: function(){
    this.getSegments();
    this.getUserEmails();
    this.getUserSms();
    if(this.$route.params.id){
      this.getMailing();
    }
  },
  mounted() {
    this.$root.$on('updateSegments', () => {
      this.getSegments();
    });
    this.$root.$on('createMailing', () => {
      this.createMailing();
    });
  },
  methods: {
    init: function(){
      if(this.segments.length > 0){
        this.mailing.segment = this.segments[0].id;
      }
    },
    getUserSms: function(){
      this.isLoading = true;
      axios.post('getUserSmsNames').then(response => {
        this.smses = response.data;
      });
    },
    getUserEmails: function(){
      this.isLoading = true;
      axios.post('getUserEmails').then(response => {
        var status = response.data.status;
        if(status){
          this.mails = response.data.mails;
          this.isLoading = false;
        }
      });
    },
    getSegments: function(){
      this.isLoading = true;
      axios.post('getSegments', this.$store.getters.user).then(response => {
        var status = response.data.status;
        if(status){
          this.segments = response.data.segments;
          this.init();
          this.isLoading = false;
        }
      });
    },
    uploadFile: function(file){
      const reader = new FileReader();
      reader.addEventListener('load', event => {
        this.mailing.text = event.target.result;
      });
      reader.readAsText(file);
    },
    getMailing: function(){
      this.isLoading = true;
      var data = {
        user_id: this.$store.getters.user,
        mailing_id: this.$route.params.id
      }
      axios.post( 'getMailing', data).then(response => {
        var status = response.data.status;
        if(status){
          this.errors = [];
          this.mailing.name = response.data.mailing.name;
          this.mailing.header = response.data.mailing.header;
          this.mailing.date = response.data.mailing.date_send.replace(' ', 'T');
          this.mailing.text = response.data.mailing.message;
          this.mailing.social = response.data.mailing.type;
          this.mailing.segment = response.data.mailing.segment_id;
          if(this.mailing.image){
            this.mailing.image = response.data.mailing.photo.replace('|-|', '');
          }
        }else{
          this.errors = response.data.errors;
        }
        this.isLoading = false;
      })
    },
    createMailing: function(){
      this.isLoading = true;
      let formData = new FormData();
      formData.append('name', this.mailing.name);
      formData.append('header', this.mailing.header);
      formData.append('date', this.mailing.date);
      formData.append('text', this.mailing.text);
      formData.append('segment', this.mailing.segment);
      formData.append('social', this.mailing.social);
      formData.append('image', this.mailing.image);
      formData.append('mail_id', this.mailing.mail);
      formData.append('sms_id', this.mailing.sms);
      axios.post( 'createMailing', formData, { headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
        var status = response.data.status;
        if(status){
          this.errors = [];
          this.mailing.name = '';
          this.mailing.header = '';
          this.mailing.date = null;
          this.mailing.text = '';
          this.mailing.social = 1;
          this.mailing.image = null;
          this.mailing.fileHTML = null;
          this.$toast.success("Рассылка успешно создана");
        }else{
          this.errors = response.data.errors;
        }
        this.isLoading = false;
      })
    },
    showUploadImageModal() {
      this.isModalUploadImageVisible = true;
    },
    closeUploadImageModal() {
      this.isModalUploadImageVisible = false;
    },
    showUploadFileModal() {
      this.isModalUploadFileVisible = true;
    },
    closeUploadFileModal() {
      this.isModalUploadFileVisible = false;
    },
    showAcceptMoneyModal() {
      this.isModalAcceptMoneyModal = true;
    },
    closeAcceptMoneyModal() {
      this.isModalAcceptMoneyModal = false;
    },
  },
  components: {
    AcceptMailingMoney,
    uploadImageModal, uploadFileModal
  }
}
</script>